module.exports = __webpack_public_path__ + "static/media/banner-mobile.83bb9b89.jpg";